import 'javascripts/all_pages.js'
import 'javascripts/all_theme_styles.js'
import { jqTextCopy, reveal, videoModal } from 'javascripts/general_scripts';
import {initGoogleCharts} from 'javascripts/utils/googleCharts';
// import { comparisonWidget } from 'javascripts/product_comparisons/comparison_widget'


// comparisonWidget();
jqTextCopy();
reveal();
videoModal();

$(document).on('change', '#date_select_list, #cs_select_list', () => {
    let cs_value = $('#cs_select_list').val(),
        date_value = $('#date_select_list').val();
    $.getScript(`${TOPDATA_PC_URL}?ab=${window.dataLayer[0].IsABT}&dateselection=${date_value}&cs=${cs_value}`, data => $.globalEval(data));
});

let chartData = [{
    id: 'market_share',
    colors: 'yellow'
}]

initGoogleCharts(chartData, 'pie');